import { postData } from "@Services/learning/global.service";
import {
  APIEnv,
  APIResponse,
  APIStatus,
} from "@Services/learning/baseInterfaces";
import { PRODUCT_API_CONSTANTS } from "@Constants/api-constants/product/product.constants";
import { SEO_MAPPING } from "@Constants/constants";

export class SeoHandlerClass {
  url: string = "";

  constructor(url: string) {
    this.url = url;
  }

  getSeoDetails = async (pathName: string) => {
    let params: any = {};
    let API_VALUE: any = "";

    if (
      pathName?.includes(SEO_MAPPING.DASHBOARD_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.DASHBOARD_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.DASHBOARD_PAGE.PATTERN,
        SEO_MAPPING.DASHBOARD_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.DASHBOARD_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.UPCOMING_EVENTS_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.UPCOMING_EVENTS_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.UPCOMING_EVENTS_PAGE.PATTERN,
        SEO_MAPPING.UPCOMING_EVENTS_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.UPCOMING_EVENTS_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.PAST_EVENTS_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.PAST_EVENTS_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.PAST_EVENTS_PAGE.PATTERN,
        SEO_MAPPING.PAST_EVENTS_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.PAST_EVENTS_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.PRACTICE_AREA_PAGE.URL_CONTAINS)
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.PRACTICE_AREA_PAGE.PATTERN,
        SEO_MAPPING.PRACTICE_AREA_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.PRACTICE_AREA_PAGE.API_VALUE;
      const url = new URL(window.location.href);
      params = new URLSearchParams(url.search);

      // Define the subject to API value mapping
      const subjectMapping: any = {
        "accounts-and-audit": "SUBJECT_ACCOUNT_AUDIT",
        "black-money": "SUBJECT_BLACK_MONEY",
        "companies-act": "SUBJECT_COMPANIES_ACT",
        "corporate-laws": "SUBJECT_CORPORATE_LAWS",
        "criminal-laws": "SUBJECT_CRIMINAL",
        customs: "SUBJECT_CUSTOMS",
        fema: "SUBJECT_FEMA",
        "fema-accgst": "SUBJECT_FEMA_ACCGST",
        gst: "SUBJECT_GST",
        "income-tax": "SUBJECT_INCOME_TAX",
        "insolvency-and-bankruptcy-code": "SUBJECT_INSOLVENCY_BANKRUPTCY_CODE",
        "international-taxation": "SUBJECT_INTERNATIONAL_TAXATION",
        "labour-laws": "SUBJECT_LABOUR_LAWS",
        others: "SUBJECT_OTHER",
        "sebi-income": "SUBJECT_SEBI_INCOME",
        "sebi-laws": "SUBJECT_SEBI_LAWS",
        "transfer-pricing": "SUBJECT_TRANSFER_PRICING",
        "uae-corporate-tax": "SUBJECT_UAE_CORPORATE_TAX",
      };

      // Define the subject and focusarea combinations to API values
      const focusAreaMapping: any = {
        "income-tax": {
          "case-laws-analysis": "SUBJECT_INCOME_TAX_CASE_LAWS",
          "amendments-and-updates": "SUBJECT_INCOME_TAX_AMENDMENTS",
        },
        gst: {
          "case-laws-analysis": "SUBJECT_GST_CASE_LAWS",
          "amendments-and-updates": "SUBJECT_GST_AMENDMENTS",
        },
        // Add more subjects and their focusarea mappings as necessary
      };

      // Get the subject from URL parameters
      const regex = /\d+-(.*)/;
      let subjectmatch = window.location.pathname.match(/\d+-(.+)/);//.match(/^\/learning\/subjects\/(\d+-[a-zA-Z0-9-]+)$/);
      if (subjectmatch && subjectmatch.length > 1 && subjectmatch[1]) {
        const subject = subjectmatch[1].toLowerCase();
        // console.log(subject, "subjectsubject");
        // console.log(match, "match");

        const matchfocusArea = params.get("focusarea")?.match(regex) || [];

        if (subject) {
          API_VALUE = subjectMapping[subject]; // Default API value based on subject
          // If a focusarea exists and the subject has special cases for focusareas
          if (
            matchfocusArea &&
            matchfocusArea.length > 1 &&
            matchfocusArea[1]
          ) {
            const focusarea = matchfocusArea[1].toLowerCase();
            if (subject && focusarea) {
              // Check if the subject has a specific mapping for focusarea
              if (
                focusAreaMapping[subject] &&
                focusAreaMapping[subject][focusarea]
              ) {
                API_VALUE = focusAreaMapping[subject][focusarea];
              } else {
                API_VALUE = "DEFAULT";
              }
            }
          }

          // console.log(API_VALUE);
        }
      }
    } else if (
      pathName?.includes(SEO_MAPPING.RECOMMENDED_VIDEOS_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.RECOMMENDED_VIDEOS_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.RECOMMENDED_VIDEOS_PAGE.PATTERN,
        SEO_MAPPING.RECOMMENDED_VIDEOS_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.RECOMMENDED_VIDEOS_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.MY_LIST.URL_CONTAINS) &&
      pathName == SEO_MAPPING.MY_LIST.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.MY_LIST.PATTERN,
        SEO_MAPPING.MY_LIST.PARAMS
      );
      API_VALUE = SEO_MAPPING.MY_LIST.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.EVENTS_WORKSHOP_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.EVENTS_WORKSHOP_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.EVENTS_WORKSHOP_PAGE.PATTERN,
        SEO_MAPPING.EVENTS_WORKSHOP_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.EVENTS_WORKSHOP_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.EVENTS_WEBINAR_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.EVENTS_WEBINAR_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.EVENTS_WEBINAR_PAGE.PATTERN,
        SEO_MAPPING.EVENTS_WEBINAR_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.EVENTS_WEBINAR_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.EVENTS_MASTERCLASS_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.EVENTS_MASTERCLASS_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.EVENTS_MASTERCLASS_PAGE.PATTERN,
        SEO_MAPPING.EVENTS_MASTERCLASS_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.EVENTS_MASTERCLASS_PAGE.API_VALUE;
    } else if (
      pathName?.includes(SEO_MAPPING.HOME_PAGE.URL_CONTAINS) &&
      pathName == SEO_MAPPING.HOME_PAGE.URL_CONTAINS
    ) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.HOME_PAGE.PATTERN,
        SEO_MAPPING.HOME_PAGE.PARAMS
      );
      API_VALUE = SEO_MAPPING.HOME_PAGE.API_VALUE;
    }
    // else if (pathName?.includes(SEO_MAPPING.PRODUCT_DETAILS.URL_CONTAINS) && pathName  != SEO_MAPPING.PRODUCT_DETAILS.URL_CONTAINS) {
    //     params = this.getRegexValue(pathName, SEO_MAPPING.PRODUCT_DETAILS.PATTERN, SEO_MAPPING.PRODUCT_DETAILS.PARAMS)
    //     API_VALUE = SEO_MAPPING.PRODUCT_DETAILS.API_VALUE
    // }
    else if (pathName.match(/^\/(\d+-[a-zA-Z0-9\-]+)$/)) {
      params = this.getRegexValue(
        pathName,
        SEO_MAPPING.PRODUCT_DETAILS.PATTERN,
        SEO_MAPPING.PRODUCT_DETAILS.PARAMS
      );
      API_VALUE = SEO_MAPPING.PRODUCT_DETAILS.API_VALUE;
    }

    return await postData(
      PRODUCT_API_CONSTANTS.SEO_DETAILS,
      {
        API_VALUE: API_VALUE,
        params: params,
      },
      APIEnv.LEARNING,
      "post"
    )
      .then((response: APIResponse | undefined) => {
        // console.log("this is api_value passed: ", API_VALUE);
        // console.log("this is params: ", params)
        if (response?.ResponseType === APIStatus.SUCCESS) {
          // console.log("this is seo response: ", response?.data)
          return response?.data;
        }
      })
      .catch((err) => {
        return null;
      });
  };

  getRegexValue(inputStr: string, inputRegex: any, params: any) {
    const inputString = inputStr;
    let result: any = {};
    const match = inputString.match(inputRegex);
    if (match) {
      for (let i = 0; i < params.length; i++) {
        const var1 = parseInt(match[i + 1], 10);
        result[params[i]] = var1;
      }
    }

    return result;
  }
}
